import { useEffect, useState } from "react"
import BarChart from "../../charts/BarChart";

const keys = {
  'Pemerintah': ["pemberi_bantuan_pemerintah"],
  'Pemuka Koperasi': ["pemberi_bantuan_koperasi"],
  'Lainnya': ["pemberi_bantuan_LSM","pemberi_bantuan_swasta/perusahaan","pemberi_bantuan_lembaga_keagamaan","pemberi_bantuan_perbankan"],
}

export default function PemberiBantuan({data}) {
  const [bentukBantuan, setBentukBantuan] = useState({})
  useEffect(() => {
    const fields = Object.keys(keys)
    const rawData = []
    const mapData = {}
    data.map(item => {
      fields.map(field => {
        let value = 0
        keys[field].map(col => {
          if (item[col] !== undefined) {
            value += item[col] ? 1: 0
          }
          return col
        })
        if (mapData[field] !== undefined) {
          mapData[field] += value
          //mapData[field].percentage = Math.round(mapData[field].value/data.length * 100) + '%'
        } else {
          mapData[field] = 0
        }
        return field
      })
      return item
    })
    Object.keys(mapData).map(key => {
      rawData.push(((mapData[key]/data.filter(field => field['pemberi_bantuan_pemerintah'] !== undefined).length) * 100).toFixed(1))
      return key
    })
    setBentukBantuan(rawData)
  }, [data]);

  return (
    <>
      <BarChart
        width={600}
        height={500}
        isXaxis={false}
        data={{
          labels: Object.keys(keys),
          datasets: [
            {
              label: '',
              data: bentukBantuan,
              backgroundColor: [
                '#048737',
                '#048737',
                '#048737',
                '#048737',
                '#048737',
                '#048737',
              ],
            },
          ]
        }}
      />
    </>
  )
}
